import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from '@/locales/en.json'
import es from '@/locales/es.json'

const locale = document.documentElement.lang || 'es'

if (!i18n.isInitialized) {
  void i18n.use(initReactI18next).init({
    lng: locale,
    fallbackLng: 'es',
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  })
}

export default i18n
